import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListAdmins from './list-admins';
import CreateAdmin from './create-admin';
import AdminDetail from './admin-detail';
import UpdateAdminRole from './update-admin-role';
import AllUsers from './all-users';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const AdminManagementRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/list-admins" element={<ListAdmins />} />
            <Route path="/create-admin" element={<CreateAdmin />} />
            <Route path="/admin-detail/:id" element={<AdminDetail />} />
            <Route path="/update-admin-role/:id" element={<UpdateAdminRole />} />
            <Route path="/all-users" element={<AllUsers />} />
            <Route path="/" element={<ListAdmins />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default AdminManagementRoutes; 